export const EL_MODE_CREATE = "EL_MODE_CREATE";
export const EL_MODE_UPDATE = "EL_MODE_UPDATE";

export const EL_STEP_DATA = "EL_STEP_DATA";
export const EL_STEP_CONNECTION = "EL_STEP_CONNECTION";
export const EL_STEP_FILTER = "EL_STEP_FILTER";
export const EL_STEP_LOAD = "EL_STEP_LOAD";
export const EL_STEP_STRUCTURE = "EL_STEP_STRUCTURE";
export const EL_STEP_DIMENSIONS = "EL_STEP_DIMENSIONS";
export const EL_STEP_ATTRIBUTES = "EL_STEP_ATTRIBUTES";
export const EL_STEP_SEMANTIC = "EL_STEP_SEMANTIC";
export const EL_STEP_MAPPING = "EL_STEP_MAPPING";

export const EL_SOURCE_FORMAT_CSV = "EL_SOURCE_FORMAT_CSV";
export const EL_SOURCE_FORMAT_XLS = "EL_SOURCE_FORMAT_XLS";
export const EL_SOURCE_FORMAT_SDMX_EP = "EL_SOURCE_FORMAT_SDMX_EP"
export const EL_SOURCE_FORMAT_DB = "EL_SOURCE_FORMAT_DB";

export const EL_COL_TYPE_DIMENSION = "EL_COL_TYPE_DIMENSION";
export const EL_COL_TYPE_MEASURE = "EL_COL_TYPE_MEASURE";
export const EL_COL_TYPE_ATTRIBUTE = "EL_COL_TYPE_ATTRIBUTE";
export const EL_COL_TYPE_TRANSLATION = "EL_COL_TYPE_TRANSLATION";
export const EL_COL_TYPE_IGNORE = "EL_COL_TYPE_IGNORE";

export const EL_DIMENSION_ROLE_FREQUENCY = "EL_DIMENSION_ROLE_FREQUENCY";
export const EL_DIMENSION_ROLE_TIME = "EL_DIMENSION_ROLE_TIME";
export const EL_DIMENSION_ROLE_TERRITORY = "EL_DIMENSION_ROLE_TERRITORY";
export const EL_DIMENSION_ROLE_MEASURE = "EL_DIMENSION_ROLE_MEASURE";
export const EL_DIMENSION_ROLE_GENERIC = "EL_DIMENSION_ROLE_GENERIC";

export const EL_ATTRIBUTE_REFERS_OBSERVATION = "EL_ATTRIBUTE_REFERS_OBSERVATION";
export const EL_ATTRIBUTE_REFERS_DIMENSION = "EL_ATTRIBUTE_REFERS_DIMENSION";
export const EL_ATTRIBUTE_REFERS_DATASET = "EL_ATTRIBUTE_REFERS_DATASET";

export const EL_SEMANTIC_CONCEPT_NEW = "EL_SEMANTIC_CONCEPT_NEW";
export const EL_SEMANTIC_CONCEPT_EXISTING = "EL_SEMANTIC_CONCEPT_EXISTING";

export const EL_LOAD_CUBE_COMPONENT_TYPE_ATTRIBUTE = 0;
export const EL_LOAD_CUBE_COMPONENT_TYPE_DIMENSION = 1;
export const EL_LOAD_CUBE_COMPONENT_TYPE_MEASURE = 2;
export const EL_LOAD_CUBE_COMPONENT_TYPE_TIME_DIMENSION = 3;

const STARTED_STEP = "STARTED";
const CREATING_CUBE_STEP = "CREATING_CUBE";
const IMPORTING_DATA_STEP = "IMPORTING_DATA";
const CREATING_DATAFLOW_STEP = "CREATING_DATAFLOW";
const CREATING_MAPPING_STEP = "CREATING_MAPPING";
const PUBLISHING_DATAFLOW_STEP = "PUBLISHING_DATAFLOW";
const COMPLETED_STEP = "COMPLETED";
const TRASCODING_STEP = "TRASCODING";
const DOWNLOADING_DATA_STEP = "DOWNLOADING_DATA";

export const getDataImportStatusTranslation = t => {

  const translate = t => ({
    [STARTED_STEP]: t('components.easyLoading.dataImportStatus.STARTED'),
    [CREATING_CUBE_STEP]: t('components.easyLoading.dataImportStatus.CREATING_CUBE'),
    [IMPORTING_DATA_STEP]: t('components.easyLoading.dataImportStatus.IMPORTING_DATA'),
    [CREATING_DATAFLOW_STEP]: t('components.easyLoading.dataImportStatus.CREATING_DATAFLOW'),
    [CREATING_MAPPING_STEP]: t('components.easyLoading.dataImportStatus.CREATING_MAPPING'),
    [PUBLISHING_DATAFLOW_STEP]: t('components.easyLoading.dataImportStatus.PUBLISHING_DATAFLOW'),
    [COMPLETED_STEP]: t('components.easyLoading.dataImportStatus.COMPLETED'),
    [TRASCODING_STEP]: t('components.easyLoading.dataImportStatus.TRASCODING'),
    [DOWNLOADING_DATA_STEP]: t('components.easyLoading.dataImportStatus.DOWNLOADING_DATA')
  });

  return translate(t !== undefined ? t : str => str);
};

export const getELDimensionRoleTranslations = t => {

  const translate = t => ({
    [EL_DIMENSION_ROLE_GENERIC]: t('components.easyLoading.dimensions.table.dimension.role.generic'),
    [EL_DIMENSION_ROLE_FREQUENCY]: t('components.easyLoading.dimensions.table.dimension.role.frequency'),
    [EL_DIMENSION_ROLE_TIME]: t('components.easyLoading.dimensions.table.dimension.role.time'),
    [EL_DIMENSION_ROLE_TERRITORY]: t('components.easyLoading.dimensions.table.dimension.role.territory'),
    [EL_DIMENSION_ROLE_MEASURE]: t('components.easyLoading.dimensions.table.dimension.role.measure')
  });

  return translate(t !== undefined ? t : str => str);
};

export const getELAtributeRefersTranslations = t => {

  const translate = t => ({
    [EL_ATTRIBUTE_REFERS_OBSERVATION]: t('components.easyLoading.attributes.table.refers.observation'),
    [EL_ATTRIBUTE_REFERS_DIMENSION]: t('components.easyLoading.attributes.table.refers.dimension'),
    [EL_ATTRIBUTE_REFERS_DATASET]: t('components.easyLoading.attributes.table.refers.dataset')
  });

  return translate(t !== undefined ? t : str => str);
};

export const getELSemanticConceptTypeTranslations = t => {

  const translate = t => ({
    [EL_SEMANTIC_CONCEPT_NEW]: t('components.easyLoading.semantic.table.conceptType.new'),
    [EL_SEMANTIC_CONCEPT_EXISTING]: t('components.easyLoading.semantic.table.conceptType.existing')
  });

  return translate(t !== undefined ? t : str => str);
};

export const newMapping = {
  IDMapping: -1,
  Name: ""
};


// WEBPACK FOOTER //
// ./src/components/easy-loading/constants.js